import { View, Text, TouchableOpacity } from "react-native";
import React, { useState } from "react";
import { observer } from "mobx-react";
import GlobalStyles from "../../Resources/Styles";
import { AntDesign } from "@expo/vector-icons";
import { useDevice, useScreenDimensions } from "../_layout";
import Colors from "../../Resources/Color";
import { useTranslation } from "react-i18next";

const CTAButton = observer(({ disabled, action, plus, text }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();
  const { t } = useTranslation();
  return (
    <TouchableOpacity
      style={{
        marginLeft: screenSize === "small" ? 8 : 12,
        backgroundColor: "transparent",
        // borderWidth: 0,
        borderRadius: 14,
        opacity: isHovered ? 0.8 : disabled ? 0.5 : 1,
      }}
      onPress={action}
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <View
        style={[
          GlobalStyles.HStack,
          {
            height: 40,
            borderRadius: 14,
            backgroundColor: Colors.bubbleColor,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
            paddingHorizontal: 8,
          },
        ]}
      >
        {plus && <AntDesign name="plus" size={18} color={Colors.whiteColor} />}
        <Text
          style={{
            color: Colors.whiteColor,
            marginLeft: 4,
            fontSize: 14,
          }}
        >
          {t(text)}
        </Text>
      </View>
    </TouchableOpacity>
  );
});

export default CTAButton;
